import SubHeaders from '@/components/Headers/SubHeaders'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

const Identity = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.employeesManage,
                        title: t('employee-manage'),
                    },
                    {
                        path: generatePathDatacentral(paths.employeeUpdate, {
                            id,
                        }),
                        title: `#${id}`,
                    },
                    {
                        path: generatePathDatacentral(paths.employeeUpdate, {
                            id,
                        }),
                        title: t('edit'),
                    },
                ]}
            />
        </div>
    )
}

export default Identity
